'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _FormField = require('./FormField');

var _primitives = require('./primitives');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FieldInfo = function FieldInfo(props, context) {
  var field = (0, _FormField.getField)(context.fields, props.name || context.name, context.namePrefix) || {};
  var value = context.values && (0, _FormField.getField)(context.values, props.name || context.name, context.namePrefix);
  /*const InfoField = props.renderInfo || props.render || context.renderInfo(props.type || field.type)
  if (InfoField) {
    return <InfoField {...props} field={field} value={value} />
  }*/

  return _react2["default"].createElement(_primitives.View, null);
};

FieldInfo.propTypes = {
  renderInfo: _propTypes2["default"].func,
  render: _propTypes2["default"].func
};
FieldInfo.defaultProps = {
  renderInfo: null,
  render: null
};
FieldInfo.contextTypes = {
  fields: _propTypes2["default"].object,
  mode: _propTypes2["default"].string,
  name: _propTypes2["default"].string,
  renderInfo: _propTypes2["default"].func,
  values: _propTypes2["default"].object,
  namePrefix: _propTypes2["default"].string
};
exports["default"] = FieldInfo;